<template>
  <div>
    <keep-alive>
      <router-view />
    </keep-alive>
    <div class="fixed_contact">
      <div @click="openTel" class="fixed_contact_item">
        <img class="fixed_contact_img" src="@/assets/home/phone.png" alt=""/>
        <div class="fixed_contact_text">{{ l.home_phone }}</div>
      </div>
      <div @click="openLine" class="fixed_contact_item">
        <img class="fixed_contact_img" src="@/assets/home/line.png" alt=""/>
        <div class="fixed_contact_text">{{ l.home_free_consultation }}</div>
      </div>
    </div>
    <Tabbar class="tabbr_box" v-model="active" placeholder @change="change">
      <TabbarItem to="/home" name="/home">
        <span
          class="tabFontColor"
          :class="active == '/home' && 'tabFontColor_select'"
          >{{ l.tabbar_home }}</span
        >
        <template #icon="props">
          <div class="icon_box">
            <!-- <i
                            class="iconfont icon-shouye"
                            :style="{ 'font-size': props.active ? '30px' : '' }"
                            ></i> -->
            <img
              :style="{
                width: props.active ? '30px' : '30px',
                height: props.active ? '30px' : '30px',
              }"
              :src="
                props.active
                  ? require('@/assets/icon/home_sel@2x.png')
                  : require('@/assets/icon/home_nor@2x.png')
              "
            />
          </div>
        </template>
      </TabbarItem>
      <TabbarItem to="/order" name="/order">
        <span
          class="tabFontColor"
          :class="active == '/order' && 'tabFontColor_select'"
          >{{ l.tabbar_order }}</span
        >
        <template #icon="props">
          <div class="icon_box">
            <img
              :style="{
                width: props.active ? '30px' : '30px',
                height: props.active ? '30px' : '30px',
              }"
              :src="
                props.active
                  ? require('@/assets/icon/order_sel@2x.png')
                  : require('@/assets/icon/order_nor@2x.png')
              "
            />
          </div>
        </template>
      </TabbarItem>
      <TabbarItem to="/my" name="/my">
        <span
          class="tabFontColor"
          :class="active == '/my' && 'tabFontColor_select'"
          >{{ l.tabbar_my }}</span
        >
        <template #icon="props">
          <div class="icon_box">
            <img
              :style="{
                width: props.active ? '30px' : '30px',
                height: props.active ? '30px' : '30px',
              }"
              :src="
                props.active
                  ? require('@/assets/icon/mine_sel@2x.png')
                  : require('@/assets/icon/mine_nor@3x.png')
              "
            />
          </div>
        </template>
      </TabbarItem>
    </Tabbar>
  </div>
</template>

<script>
import {appConfig} from "@/services/user";
import { Tabbar, TabbarItem } from "vant";
import l from "@/locales";
export default {
  name: "home",
  components: {
    Tabbar,
    TabbarItem,
  },
  data() {
    return {
      active: "",
      l: {...l.tabbar,...l.home},
      config: {},
    };
  },
  watch: {
    $route(newRout) {
      this.active = newRout.path;
    },
  },
  created() {
    appConfig().then(res=>{
      const arr = JSON.parse(res.result?.about?.additionalContactInfo || "[]");
      const result = arr.reduce((acc, item) => {
        acc[item.name] = item.value;
        return acc;
      }, {});
      this.config = result;
      console.log("appConfig",result)
    })
  },
  mounted() {
    console.log(this.l);
    this.active = this.$route.path;
  },
  methods: {
    openTel(){
      window.location.href = "tel:" + this.config.phone;
    },
    openLine(){
      window.location.href = this.config.line;
    },
    change(val) {
      console.log(val);
    },
  },
};
</script>

<style lang="less" scoped>
.fixed_contact {
  position: fixed;
  left: 0;
  bottom: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  .fixed_contact_item {
    flex: 1 0 0;
    height: 40px;
    background: #EF9614;
    display: flex;
    align-items: center;
    justify-content: center;
    .fixed_contact_img {
      width: 22px;
      height: 22px;
      margin-right: 6px;
    }

    .fixed_contact_text {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #FFFFFF;
    }

    &:last-child{
      background: #0BC471;
    }
  }
}
.tabbr_box {
  /deep/ .van-tabbar {
    overflow: hidden;
    height: 50px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.4);
  }
  /deep/ .van-tabbar-item--active {
    background: transparent;
  }
}
.icon_box {
  height: 30px;
}
.tabFontColor {
  font-size: 11px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #9EA5AE;
}
.tabFontColor_select {
  font-weight: 500;

  color: #EF9614;
}
</style>
